import { render, staticRenderFns } from "./XModal.vue?vue&type=template&id=13bf9e06"
import script from "./XModal.vue?vue&type=script&lang=js"
export * from "./XModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports